import { httpTokenCommon } from "../helper/http-common";
import { InitiatedWorkflowData, ReturnType } from "../types/returnManagement";

class ReturnRequestService {
  getReturnList(params: ReturnType) {
    return httpTokenCommon.get("returns/search", { params });
  }
  getReturnDashboardData() {
    return httpTokenCommon.get("returns/dashboard");
  }
  getWorkflowById(id: string) {
    return httpTokenCommon.get(`returns/${id}`);
  }
  initiateReturn(inputData: InitiatedWorkflowData) {
    return httpTokenCommon.post(`returns`, inputData);
  }
  getBatchHistory(productId: string) {
    return httpTokenCommon.get(
      `returns/batchhistory?productNumber=${productId}`
    );
  }
  getCustomerBatchBalance(productNumber: string) {
    return httpTokenCommon.get(
      `returns/GetCustomerBatchBalance?productNumber=${productNumber}`
    );
  }
  // Returns all CustomerBatchBalance records for the current customer (CustomerHeldQty > 0).
  // Calls the existing GetCustomerBatchBalance endpoint — productNumber is now optional
  // after the backend makes it nullable (string? productNumber = null).
  // With no productNumber → returns ALL products the customer holds (for product dropdown).
  // With productNumber   → returns that item's batches only (for batch table).
  getReturnableItems(productNumber?: string) {
    const url = productNumber
      ? `returns/GetCustomerBatchBalance?productNumber=${encodeURIComponent(productNumber)}`
      : "returns/GetCustomerBatchBalance";
    return httpTokenCommon.get(url);
  }
  updateReturn(id: string, data: Record<string, unknown>) {
    return httpTokenCommon.put(`returns/${id}`, data);
  }
  approveReturn(requestId: string) {
    return httpTokenCommon.post("returns/approve", JSON.stringify(requestId), {
      headers: { "Content-Type": "application/json" },
    });
  }
  rejectReturn(requestId: string, rejectionReason: string, rejectionNote?: string) {
    return httpTokenCommon.post(
      "returns/reject",
      { requestId, rejectionReason, rejectionNote: rejectionNote ?? "" },
      { headers: { "Content-Type": "application/json" } }
    );
  }
}

const returnRequestService = new ReturnRequestService();
export default returnRequestService;
